import { createContext } from 'react'

import { type getCoverageAuditLogsQueryKey } from 'components/brokers/coverage_audit_logs/CoverageAuditLogsTable'

interface CoverageAuditLogsContextValue {
  getCoverageAuditLogsQueryKey: ReturnType<typeof getCoverageAuditLogsQueryKey>
}

const CoverageAuditLogsContext = createContext<CoverageAuditLogsContextValue>({
  getCoverageAuditLogsQueryKey: [],
})

export default CoverageAuditLogsContext
